import * as React from "react"
import { translateCountryName, formatDate } from "@ui-seeker/utils"

import {LabelCountry, RetailerBlock} from "@components";


export default function retailerColumn() {
	return  {
		name: "retailer", label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country, siteURL, date }) => <RetailerBlock 
				retailer={value}
				country={country}
				siteURL={siteURL}
			/>
		}
	}
}